import React from 'react';
import { TimesheetTableRow } from '../../TimesheetsTable.types';

import { AccountStatusCell } from '../AccountStatusCell';
import { EmployeeStatusCell } from '../EmployeeStatusCell';
import { ProjectStatusCell } from '../ProjectStatusCell';

const TimesheetEntityStatusCell: React.FC<{ record: TimesheetTableRow }> = ({ record }) => {
  if ('accountName' in record && record.periodState) {
    return <AccountStatusCell record={record} />;
  }
  if ('projectName' in record && record.periodState) {
    return <ProjectStatusCell record={record} />;
  }
  if ('employeeName' in record) {
    return <EmployeeStatusCell record={record} />;
  }
  return null;
};

export { TimesheetEntityStatusCell };
